import { render, staticRenderFns } from "./SystemDialog.vue?vue&type=template&id=446ab6b9&scoped=true&"
import script from "./SystemDialog.vue?vue&type=script&lang=ts&"
export * from "./SystemDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SystemDialog.vue?vue&type=style&index=0&id=446ab6b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446ab6b9",
  null
  
)

export default component.exports